<template>
	<div class="row">
		<div class="cell">{{ date }}</div>
		<div class="cell"><router-link :to="`/commerce/customers/${ order.id }/details`" class="link">{{ order.shipping_recipient }}</router-link></div>
		<div class="cell">{{ order.order_total / 100 | currency }}</div>
		<div class="cell"><span class="tag" :class="statusClassColor">{{ order.status.toLowerCase() | capitalize  }}</span></div>
		<div class="cell buttons align-right">
			<router-link :to="`/commerce/orders/${ order.id }/details`" class="button"><div class="hover-title">Details</div><span class="fa fa-search"></span></router-link>
		</div>
	</div>
</template>

<script>

import moment from 'moment-timezone';
import OrderMixin from '../mixins/OrderMixin';

export default {

	props: [ 'order' ],

	mixins: [ OrderMixin ],

};

</script>
